module.exports = __webpack_public_path__ + "static/media/11_r_ruini_60.05_77.78.ae76667a.png";